export default __webpack_public_path__ + "static/media/48.8e33b2f9.png";